import * as XLSX from 'xlsx';

// Column headers for the downloadable CML import template.
//
// IMPORTANT — these names are deliberately chosen so a filled-in template
// auto-maps on the wizard's "Map" step with ZERO manual mapping. Each header
// normalizes (lowercase, strip non-alphanumerics) to a token that the dialog's
// autoSuggest() matches — e.g. "Tag No" -> "tagno", "Last Reading" -> "lastreading".
// If you rename a header here, keep it aligned with the autoSuggest keyword lists
// in CmlBulkImportDialog.vue, or the template stops self-mapping on re-import.
//
// Long format: one row per thickness reading; the CML + TML columns repeat for
// each reading of the same point. Only "Tag No" is mandatory — TML and reading
// columns are optional (see the importer's per-tier gating).
const TEMPLATE_HEADERS = [
  'Tag No', // Master Tag (REQUIRED) — must already exist in the selected facility
  'CML ID', // External Ref — upsert key; re-import updates instead of duplicating
  'CML Number',
  'Description',
  'CML Type',
  'Design Thickness',
  'Minimum Thickness',
  'Inspection Strategy',
  'ISO Reference',
  'Next Inspection Date', // dd/MM/yyyy
  'Follow-Up Date', // dd/MM/yyyy
  'Observation',
  'Recommendation',
  'TML Point No', // measurement point under the CML (optional)
  'Last Reading', // thickness value in mm (optional; needs TML Point No + Reading Date)
  'Reading Date', // dd/MM/yyyy (optional)
  'Inspection No', // links the reading to an EXISTING inspection (optional)
];

/**
 * Builds and downloads a headers-only .xlsx the user can fill in and re-import.
 * Generated client-side from TEMPLATE_HEADERS (single source of truth) so the
 * template can never drift from the columns the importer actually understands.
 * @returns {void}
 */
export function downloadCmlImportTemplate() {
  const worksheet = XLSX.utils.aoa_to_sheet([TEMPLATE_HEADERS]);
  // Comfortable column widths so the headers are readable the moment it opens.
  worksheet['!cols'] = TEMPLATE_HEADERS.map((h) => ({ wch: Math.max(16, h.length + 2) }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'CML Import');
  // writeFile triggers a browser download via a Blob (SheetJS wires up the anchor).
  XLSX.writeFile(workbook, 'CML_Import_Template.xlsx');
}
